export default "__VITE_ASSET__a7dcd000__"